import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Pages/Login/login/login.component';
import { HomeComponent } from './Pages/home/home.component';
import { SchedulerComponent } from './Pages/Components/scheduler/scheduler.component';
import { ForgotPasswordComponent } from './Pages/Login/forgot-password/forgot-password.component';
import { PasswordResetComponent } from './Pages/Login/password-reset/password-reset.component';
import { ServiceMainPageComponent } from './Pages/service-main-page/service-main-page.component';
import { PatientsMainPageComponent } from './Pages/patients-main-page/patients-main-page.component';
import { StaffMainPageComponent } from './Pages/staff-main-page/staff-main-page.component';
import { AppointmentSummaryComponent } from './Pages/appointment-summary/appointment-summary.component';
import { ReportsMainPageComponent } from './Pages/reports-main-page/reports-main-page.component';
import { SurveyComponent } from './Pages/survey/survey.component';


export const routes: Routes = [

  { path: 'login', component: LoginComponent, data: { hideNavbar: true, requireLogin: false } },
  { path: 'forgot-password', component: ForgotPasswordComponent, data: { hideNavbar: true, requireLogin: false } },
  { path: 'password-reset', component: PasswordResetComponent, data: { hideNavbar: true, requireLogin: false } },
  { path: 'member-survey', component: SurveyComponent, data: { hideNavbar: true, requireLogin: false } },

  //{ path: 'home', component: HomeComponent,  data: { requireLogin: true } },
  { path: 'scheduler', component: SchedulerComponent, data: { requireLogin: true } },
  { path: 'services', component: ServiceMainPageComponent, data: { requireLogin: true } },
  { path: 'patients', component: PatientsMainPageComponent, data: { requireLogin: true } },
  { path: 'staff', component: StaffMainPageComponent, data: { requireLogin: true } },
  { path: 'reports', component: ReportsMainPageComponent, data: { requireLogin: true } },
  { path: 'appointment-summary', component: AppointmentSummaryComponent, data: { requireLogin: true } },


  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
